import React from "react";
import classes from "./styles.module.scss";
import Skeleton from "react-loading-skeleton";

export default function BlogLoading({
  length = 4,
  lineCount = 5,
  circle = true,
}) {
  return Array.from({ length }).map((_, idx) => (
    <div className={classes.BlogLoading} key={"BlogLoading" + idx}>
      {circle && (
        <div className={classes.BlogLoading__img}>
          <Skeleton circle height="100%" containerClassName="avatar-skeleton" />
        </div>
      )}
      <div className={classes.BlogLoading__content}>
        <Skeleton count={lineCount} />
      </div>
    </div>
  ));
}
